import { Flex, SidebarContent, SidebarPart } from '@eleveo/components-react';
import React, { useMemo } from 'react';

import { useIntegrations } from '../../../app/IntegrationsProvider';
import { getSupportedJobs, getSupportedStreams } from '../../../scene/integrations/config';
import { ETL_INTEGRATION_TYPE } from '../../configuration/types';
import { IntegrationTitle } from '../../sideBar/integrations/IntegrationTitle';
import { IntegrationsHeader } from '../../sideBar/integrations/IntegrationsHeader';
import { FieldAccountId } from '../fields/FieldAccountId';
import { FieldApiUrl } from '../fields/FieldApiUrl';
import { FieldClientId } from '../fields/FieldClientId';
import { FieldClientSecret } from '../fields/FieldClientSecret';
import { FieldIntegrationName } from '../fields/FieldIntegrationName';
import { IntegrationJobs } from '../jobs/IntegrationJobs';
import { FieldGroupSupervisors } from '../jobs/userSync/FieldGroupSupervisors';
import { RoleMapping } from '../jobs/userSync/RoleMapping';
import { IntegrationRolesProvider } from '../roles/IntegrationRolesProvider';

export const ZoomCCForm: React.FC = () => {
  const { integrationType } = useIntegrations();

  if (integrationType !== ETL_INTEGRATION_TYPE.zoomcc) throw new Error('ZoomCCForm: invalid integrationType!');

  const availableJobs = useMemo(() => getSupportedJobs(integrationType), [integrationType]);
  const availableStreams = useMemo(() => getSupportedStreams(integrationType), [integrationType]);

  return (
    <IntegrationRolesProvider>
      <IntegrationsHeader />
      <SidebarContent>
        <SidebarPart>
          <Flex column gap={20} className="p-20">
            <IntegrationTitle />
            <FieldIntegrationName />
            <FieldApiUrl />
            <FieldAccountId />
            <FieldClientId />
            <FieldClientSecret />
            <IntegrationJobs availableJobs={availableJobs} availableStreams={availableStreams} />
          </Flex>
        </SidebarPart>
        <SidebarPart>
          <RoleMapping>
            <FieldGroupSupervisors />
          </RoleMapping>
        </SidebarPart>
      </SidebarContent>
    </IntegrationRolesProvider>
  );
};
